import { createFileRoute } from '@tanstack/react-router'
import { StaffDetailPage } from '@/pages/staff-detail'

function StaffDetailRoute() {
  const { staffId } = Route.useParams()
  return <StaffDetailPage staffId={staffId} />
}

export const Route = createFileRoute('/_authenticated/staff/$staffId')({
  staticData: { title: 'Staff Member' },
  component: StaffDetailRoute,
})
